'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'volume-high';
var width = 640;
var height = 512;
var aliases = [128266,"volume-up"];
var unicode = 'f028';
var svgPathData = 'M301.2 34.98c-4.201-1.895-8.727-2.902-13.16-2.902c-7.697 0-15.29 2.876-21.27 8.192L131.8 160.1H48c-26.51 0-48 21.45-48 47.96v95.92c0 26.51 21.49 47.96 48 47.96h83.84l134.9 119.8C272.7 477 280.3 479.8 288 479.8c4.438 0 8.959-.9292 13.16-2.835C312.7 471.8 320 460.5 320 447.9V64.12C320 51.53 312.7 40.14 301.2 34.98zM287.1 447.1L143.1 319.1H48c-8.822 0-16-7.16-16-15.96v-96c0-8.801 7.178-15.96 16-15.96h95.1l143.1-127.1c.0078-.0078-.0039 .0039 0 0L287.1 447.1zM520.9 34.7c-7.328-4.906-17.27-2.953-22.2 4.391c-4.922 7.344-2.953 17.28 4.391 22.2C568.8 105.3 608 178.1 608 256s-39.22 150.7-104.9 194.7c-7.344 4.922-9.312 14.86-4.391 22.2C501.8 477.5 506.9 480 512 480c3.062 0 6.156-.875 8.891-2.703C595.5 427.3 640 344.6 640 255.1S595.5 84.66 520.9 34.7zM459.4 98.7c-7.344-4.922-17.28-2.953-22.2 4.391s-2.953 17.28 4.391 22.2C485.7 154.8 512 203.7 512 256s-26.33 101.2-70.44 130.7c-7.344 4.922-9.312 14.86-4.391 22.2C440.3 413.5 445.3 416 450.5 416c3.062 0 6.156-.875 8.891-2.703C512.4 377.8 544 318.1 544 255.1S512.4 134.2 459.4 98.7zM406.4 178.7c-7.328-4.922-17.28-2.953-22.2 4.391s-2.953 17.28 4.391 22.2C405.8 216.8 416 235.7 416 256s-10.23 39.23-27.38 50.7c-7.344 4.922-9.312 14.86-4.391 22.2C387.3 333.5 392.4 336 397.5 336c3.062 0 6.156-.875 8.891-2.703C432.5 315.9 448 286.1 448 255.1S432.5 196.1 406.4 178.7z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faVolumeHigh = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;